import type { TileImage, Variation } from '@shared/types/types.ts';
import type { ProductLink } from '@tile/components/product-title/ProductLink';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';
import { type LayoutImageIntents, getLayoutImages } from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';
import { mapLink } from '../mapping/ProductLink';

export type DefaultLayout = {
    /**
 *
 */
    readonly variation: Variation;

    /**
 *
 */
    readonly title: ProductTitle;

    readonly link: ProductLink;

    readonly images: TileImage[];

    readonly primaryImage: TileImage;
};

/**
 *
 */
export function createDefaultLayout(
    variation: Variation,
    showTopInfos: boolean,
    intents?: LayoutImageIntents,
): DefaultLayout {
    const patchedVariation: Variation = {
        ...variation,
        topInfos: showTopInfos && variation.topInfos?.length ? variation.topInfos : undefined,
    };
    const { images, primaryImage } = getLayoutImages(variation, intents);
    return {
        variation: patchedVariation,
        title: mapTitle(variation, showTopInfos && !!variation.topInfos?.length),
        link: mapLink(variation),
        images,
        primaryImage,
    };
}
